import image from '../images/banner.png';
import image2 from '../images/banner2.png';

type Props = {
  title: string;
  content: string;
};

export default function Example({ title, content }: Props) {
  return (
    <div className="relative isolate overflow-hidden bg-custom-7 py-16 sm:py-20 group">
      {/* 🌈 SVG 动画背景（仅中屏及以上显示） */}
      <svg
        className="absolute inset-0 -z-10 w-full h-full animate-fade-in"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid slice"
        viewBox="0 0 1000 400"
        fill="none"
      >
        {/* 动态路径 */}
        {/* <path
          d="M 0 200 Q 200 100, 400 200 T 1000 200"
          stroke="url(#gradient1)"
          strokeWidth="3"
          fill="none"
          className="animate-path-float"
          style={{ filter: 'drop-shadow(0 0 6px rgba(192, 132, 252, 0.4))' }}
        /> */}
        <path
          d="M 0 250 Q 200 150, 400 250 T 1000 250"
          stroke="url(#gradient2)"
          strokeWidth="2.5"
          fill="none"
          className="animate-path-float-strong"
          style={{ filter: 'drop-shadow(0 0 6px rgba(147, 51, 234, 0.3))' }}
        />

        {/* 中心旋转光圈 */}
        <circle
          cx="500"
          cy="200"
          r="150"
          stroke="url(#radialGradient)"
          strokeWidth="1.5"
          className="animate-spin-slow"
          style={{ transformOrigin: 'center', transformBox: 'fill-box' }}
        />

        {/* NDIS 样式关键词气泡 */}
        {/* <text x="120" y="80" fontSize="18" fill="#9333ea" className="animate-keyword-float">Empower</text>
        <text x="800" y="100" fontSize="18" fill="#60a5fa" className="animate-keyword-float">Support</text>
        <text x="500" y="360" fontSize="18" fill="#f472b6" className="animate-keyword-float">Choice</text> */}

        {/* NDIS 图标占位（可替换为实际图标） */}
        
        {/* 默认大屏 circle */}
        <circle
          cx="100"
          cy="180"
          r="14"
          fill="#C084FC"
          className="hidden sm:block animate-icon-pulse"
        />

        {/* 小屏专用大半径 circle */}
        <circle
          cx="200"
          cy="180"
          r="18"
          fill="#C084FC"
          className="block sm:hidden animate-icon-pulse"
        />
        {/* <circle cx="600" cy="120" r="14" fill="#8B5CF6" className="animate-icon-pulse" /> */}

        {/* 渐变定义 */}
        <defs>
          <linearGradient id="gradient1" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#c084fc" stopOpacity="0.6" />
            <stop offset="100%" stopColor="#f472b6" stopOpacity="0.4" />
          </linearGradient>
          <linearGradient id="gradient2" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#60a5fa" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#9333ea" stopOpacity="0.2" />
          </linearGradient>
          <radialGradient id="radialGradient" r="50%" cx="50%" cy="50%">
            <stop offset="0%" stopColor="#a855f7" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#ec4899" stopOpacity="0" />
          </radialGradient>
        </defs>
      </svg>

        {/* <img
          src={image}
          alt="Right Banner"
          className="hidden lg:block absolute top-1/2 right-0 transform -translate-y-1/2 w-48 
                    opacity-100 group-hover:opacity-0 transition-opacity duration-500 ease-in-out"
        />

        <img
          src={image2}
          alt="Left Banner"
          className="hidden lg:block absolute top-1/2 left-0 transform -translate-y-1/2 w-48 
                    opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-in-out"
        /> */}
        
      

      {/* 正文内容 */}
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-4xl text-center">
          <h2 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
            {title}
          </h2>
          <p className="mt-6 text-2xl leading-8 text-gray-700">
            {content}
          </p>
        </div>
      </div>
    </div>
  );
}

